import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

export default function DeclineDocumentPopup({ data, id }) {
  const { text, title } = data;
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <BasePopup className="error-modal">
      <div className="popup__content">
        <Icon className="error-modal__icon" name="error" />
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleClose} />
      </div>
    </BasePopup>
  );
}

DeclineDocumentPopup.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
